import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoContato, cadastrarTipoContato, alterarTipoContato, excluirTipoContato } from './tipos_contatos_service';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
export var TiposContatosAlterar = function () {
    var services = {
        getItem: getTipoContato,
        cadastrarItem: cadastrarTipoContato,
        alterarItem: alterarTipoContato,
        excluirItem: excluirTipoContato,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.TIPOS_CONTATOS, paginaPermissao: FUNCIONALIDADES.TIPOS_CONTATOS, rota: ROUTES.TIPOS_CONTATOS, services: services });
};
export default TiposContatosAlterar;
